import type { TMemberEmailPayload } from '@/services/emailSends';

import { emailSendsService } from '@/services/emailSends';
import { errorUtils } from '@/services/errors';

type TMemberEmailOutcome = 'sent' | 'failed';

const notifyMember = async (payload: TMemberEmailPayload): Promise<TMemberEmailOutcome> => {
  const result = await emailSendsService.sendMemberEmail(payload);

  if (errorUtils.isNetworkError(result) || result.status === 'failed') {
    return 'failed';
  }

  return 'sent';
};

export type {
  TMemberEmailOutcome,
};
export {
  notifyMember,
};
